import * as React from "react";
import { DonationSummary } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
/* empty css                          */
const OrderDonationSummary = ({
  currency,
  donationAmount,
  total,
  totalWithDonation
}) => {
  const { locale, getLabel, getFormattedLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      label: getLabel("checkout.payment.donation.summary.title"),
      disclaimer: getFormattedLabel("checkout.payment.donation.summary.description", {
        labelData: {
          total: formatPrice({
            locale,
            value: totalWithDonation,
            currency,
            isCentAmount: true
          }),
          cartTotal: formatPrice({
            locale,
            value: total,
            currency,
            isCentAmount: true
          }),
          donationTotal: formatPrice({
            locale,
            value: donationAmount,
            currency,
            isCentAmount: true
          })
        }
      })
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement("tr", { className: "detail-footer__item order-donation-summary" }, /* @__PURE__ */ React.createElement("td", { colSpan: 2 }, /* @__PURE__ */ React.createElement(
    DonationSummary,
    {
      label: labels.label,
      formattedDonationAmount: formatPrice({
        locale,
        value: donationAmount,
        currency,
        isCentAmount: true
      }),
      disclaimer: labels.disclaimer
    }
  )));
};
export {
  OrderDonationSummary
};
//# sourceMappingURL=OrderDonationSummary.js.map
